import { createError } from './create-error';

export const CrossTabLinkError = createError(
  'CrossTabLinkError',
  'Failed to connect to cross-tab link',
  {
    LOCAL_STORAGE_ERROR: 'Failed to access local storage',
    NOT_CONNECTED: 'Cross-tab link is not connected',
  }
);
